// extracted by mini-css-extract-plugin
export default {"cardContainer":"CardIcon_cardContainer__+LIOm","cardImage":"CardIcon_cardImage__oAPV5","bankImage":"CardIcon_bankImage__rzheK","achCard":"CardIcon_achCard__fa4Gv"};